import {RemoteGetAddressByZipCode} from 'data/usecases';
import {GetAddressByZipCode} from 'domain/usecases';
import {makeAuthorizeHttpClientDecorator} from 'main/factories/decorators';
import {makeBFFApiUrl} from 'main/factories/http';
import {ProfileChangeDataEndpoints} from 'main/factories/usecases/endpoints';

export const makeGetAddressByZipCode = (): GetAddressByZipCode =>
	new RemoteGetAddressByZipCode(
		makeBFFApiUrl(ProfileChangeDataEndpoints.changeAddress),
		makeAuthorizeHttpClientDecorator(),
	);
